import { motion } from "framer-motion";
import { useState, useEffect, Fragment } from "react";
import { addDataLayerEvent } from "../../utils/data.layer.utils/data.layer.util";
import { pickDataValuesForButtonsGTM } from "../../utils/data.layer.utils/buttons.data.layer.util";
import { Icon } from "./Icons/generic";

const SideNavItem = props => {
	const { category, slug, item, setOpenBATD, getFormData, isMobile } = props;
	const [isActive, setIsActive] = useState(false);
	let initial = "exit"
	let open = {
		enter: { width: "auto" },
		exit: { width: 0 }
	};

	if (isMobile) {
		setIsActive(true);
		initial = "enter";
		open = {
			enter: { width: "auto" },
			exit: { width: "auto" }
		};
	}

	const handleClick = (e, item) => {
		if (item.type == "form") {
			e.preventDefault();
			getFormData(item.form.handle);
			setTimeout(() => {
				setOpenBATD(true);
			}, 550);
		}
	};

	const mouseEnterEvent = () => {
		if (!isMobile) {
			setIsActive(true);
		}
	};

	const mouseLeaveEvent = () => {
		if (!isMobile) {
			setIsActive(false);
		}
	};

	return item.type == "link" ? (
		<a
			className="sideNavItem"
			href={item.link.url}
			onMouseEnter={mouseEnterEvent}
			onMouseLeave={mouseLeaveEvent}
			target={item.link.target}
			onClick={(e) => {
				addDataLayerEvent('SideNavEventLinkButton',
					pickDataValuesForButtonsGTM(category, slug, item),
					false
				)
			}}
		>
			<motion.div
				initial={initial}
				animate={isActive ? "enter" : "exit"}
				variants={open}
				className="content"
			>
				<p>{item.link.text}</p>
			</motion.div>
			<div className="icon">
				<Icon
					icon={item.icon}
					fixedWidth
				/>
			</div>
		</a>
	) : (
		<a
			className="sideNavItem"
			href={`#${item.form.handle}`}
			onMouseEnter={mouseEnterEvent}
			onMouseLeave={mouseLeaveEvent}
			onClick={(e) => {
				addDataLayerEvent("SideNavEventFormButton",
					pickDataValuesForButtonsGTM(category, slug, item),
					false
				)
				handleClick(e, item)
			}}
		>
			<motion.div
				initial={initial}
				animate={isActive ? "enter" : "exit"}
				variants={open}
				className="content"
			>
				<p>{item.title}</p>
			</motion.div>
			<div className="icon">
				<Icon
					icon={item.icon}
					fixedWidth
				/>
			</div>
		</a>
	);
};

const SideNavRecall = props => {
	const { category, slug, item, isMobile } = props;
	const [isActive, setIsActive] = useState(false);
	let open = {
		enter: { width: "auto" },
		exit: { width: 0 }
	};

	let initial = "exit"

	if (isMobile) {
		setIsActive(true);
		initial = "enter";
		open = {
			enter: { width: "auto" },
			exit: { width: "auto" }
		};
	}

	return (
		<a
			className="sideNavItem recall"
			href={item.link.url}
			onMouseEnter={() => {
				if (!isMobile) {
					setIsActive(true);
				}
			}}
			onMouseLeave={() => {
				if (!isMobile) {
					setIsActive(false);
				}
			}}
			onClick={(e) => {
				addDataLayerEvent("SideNavEventRecallsButton",
					pickDataValuesForButtonsGTM(category, slug, item),
					false
				)
			}}
			target={item.link.target}
		>
			<div className="icon">
				<img src={item.icon.url} alt="" />
			</div>
			<motion.div
				initial={initial}
				animate={isActive ? "enter" : "exit"}
				variants={open}
				className="content"
			>
				<h3 className="title">{item.title}</h3>
				<div className="description">{item.description}</div>
			</motion.div>
		</a>
	);
};

const SideNav = props => {
	const { category, slug, navItems, getFormData, setOpenBATD } = props;
	const [openSideNav, setOpenSideNav] = useState(false);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		let mobile = window.matchMedia("(max-width: 600px)");

		if (mobile.matches) {
			setIsMobile(true);
		}
	}, []);

	const open = {
		enter: { height: "auto", opacity: 1 },
		exit: { height: 0, opacity: 0 }
	};

	return (
		<Fragment>
			<div className="sideNavHolder">
				{!isMobile && (
					<>
						{navItems && (
							navItems.map((item, index) => {
								if (item.type === "link" || item.type == "form") {
									return (
										<SideNavItem
											key={index}
											category={category}
											slug={slug}
											item={item}
											setOpenBATD={setOpenBATD}
											isMobile={isMobile}
											getFormData={getFormData}
										/>
									);
								} else {
									return (
										<SideNavRecall
											key={index}
											category={category}
											slug={slug}
											item={item}
											isMobile={isMobile}
										/>
									);
								}
							})
						)}
					</>

				)}
				{isMobile && (
					<div className="mobileSideNavHolder">
						<div className="menu" onClick={() => { setOpenSideNav(!openSideNav) }}>
							<Icon // use exact icon type to reduce import size
								icon={{ icon: 'wrench', type: 'far' }}
								fixedWidth
							/>
						</div>
						<motion.div
							initial="exit"
							animate={openSideNav ? "enter" : "exit"}
							variants={open}
							className="sideNavMobile"
						>
							{navItems.map((item, index) => {
								if (item.type === "link" || item.type == "form") {
									return (
										<SideNavItem
											key={index}
											category={category}
											slug={slug}
											item={item}
											setOpenBATD={setOpenBATD}
											getFormData={getFormData}
										/>
									);
								} else {
									return (
										<SideNavRecall
											key={index}
											category={category}
											slug={slug}
											item={item}
										/>
									);
								}
							})}
						</motion.div>
					</div>
				)}
			</div>
		</Fragment>
	);
};

export default SideNav;
